
import { defineComponent } from "vue";
import { RefresherEventDetail } from "@ionic/core";
import {
  IonButtons,
  IonContent,
  IonHeader,
  IonMenuButton,
  IonPage,
  IonTitle,
  IonToolbar,
  IonItem,
  IonLabel,
  IonList,
  IonRefresher,
} from "@ionic/vue";
import API from "@aws-amplify/api";
const apiName = "murderhungryapi";
const path = "/gamestate/123456";
const myInit = { 
};

export default defineComponent({
  name: "Messages",
  setup() {
    const refresh = function(event: CustomEvent<RefresherEventDetail>) {
      API.get(apiName, path, myInit )
        .then((response) => {
           const gamestate =  JSON.stringify(response.body);
           event.detail.complete();
        })
        .catch((error) => {
          console.log("API error "+ error);
          event.detail.complete();
        });
    };
    return {refresh};
  },
  components: {
    IonButtons,
    IonContent,
    IonHeader,
    IonMenuButton,
    IonPage,
    IonTitle,
    IonToolbar,
    IonItem,
    IonLabel,
    IonList,
    IonRefresher,
  },
});
